import { useContext, useEffect, useRef, useState } from "react"
import { Typography } from "@material-ui/core"
import axios from "axios";
import { Page } from "components";
import { ReferenceData, WhosNext } from "helpers/enums";
import { useOnLoadImages } from "helpers/hooks";
import { applicationContext } from "helpers/services";
import { useParams } from "react-router-dom";
import { BaseInfo, CustomerOrders, ServiceOrders, Message } from './components';
import moment from "moment";


export interface ITicket {
    ticketNumber: string
    title: string
    ticketTypeId: string
    ticketPriorityId: string
    ticketStatusId: string
    customerServiceAssignee: string
    assignee: string
    reporter: string
    whosNext: WhosNext
    watchers: string[]  //utenti che ricevono le notifiche
    groups: string[]
    supplier: string
    serviceOrders: IServiceOrder[]
    customerOrders: ICustomerOrder[]
    messages: IMessage[]
}

export interface IServiceOrder {
    id: string
    m3OrderNumber: string
    assignmentNumber: number
    createdOn: moment.Moment
    createdBy: string
}

export interface ICustomerOrder {
    id: string
    m3OrderNumber: string
    createdBy: string
    createdOn: moment.Moment
}

export interface IMessage {
    messageId: string
    text: string
    createdBy: string
    createdOn: moment.Moment
    attachments: Attachment[]
}

interface Attachment {
    fileId: string
    fileName: string
    downloadUrl: string
    extension: string
    isImage: boolean
    createdBy: string
    createdByCompany: string
    createdOn: moment.Moment
}

let PrintablePage = () => {
    let { id } = useParams<{ id: string }>();

    let { ticketTypes, referenceData } = useContext(applicationContext);

    const wrapperRef = useRef<HTMLDivElement>(null);
    const imagesLoaded = useOnLoadImages(wrapperRef);

    let [isLoading, setLoading] = useState(true);
    let [ticket, setTicket] = useState({} as ITicket);


    useEffect(() => {
        let getPrintableTicket = async () => {
            try {
                let response = await axios.get<{ item: ITicket }>('/api/Ticket/GetTicketPrintable', { params: { ticketId: id } });
                setTicket(response.data.item);
                setLoading(false);
            } catch (error) { }
        }

        getPrintableTicket()
    }, [])


    useEffect(() => {
        if (imagesLoaded === true) {
            window.setTimeout(() => window.print(), 100)
        }
    }, [imagesLoaded])


    return (
        <Page
            useHeader={true}
            isLoading={isLoading}
            title={ticket.title}
            subtitle={
                <Typography variant="h5">
                    {ticket.ticketNumber}
                    &nbsp;&middot;&nbsp;
                    {ticketTypes.getValueByKey(ticket.ticketTypeId, 'id', 'name')}
                    &nbsp;&middot;&nbsp;
                    {referenceData.getByKey(ReferenceData.Supplier)?.values.getValueByKey(ticket.supplier)}
                </Typography>
            }
        >
            <div ref={wrapperRef}>
                <BaseInfo ticket={ticket} />

                {ticket.customerOrders?.length > 0 &&
                    <CustomerOrders customerOrders={ticket.customerOrders} />
                }

                {ticket.serviceOrders?.length > 0 &&
                    <ServiceOrders serviceOrders={ticket.serviceOrders} />
                }

                {ticket.messages?.length > 0 &&
                    <>
                        {ticket.messages.map((message, i) =>
                            <div key={message.messageId} style={{ marginTop: i === 0 ? 16 : 'inherit' }}>
                                <Message message={message} />
                                {ticket.messages.length - 1 !== i && <hr style={{ marginBottom: '1cm' }} />}
                            </div>
                        )}
                    </>
                }
            </div>
        </Page>
    )
}

export default PrintablePage;